import { createApiAction } from 'helpers';

export const SEND_FEEDBACK_FORM = 'SEND_FEEDBACK_FORM';
export const SEND_FEEDBACK_FORM_SUCCESS = 'SEND_FEEDBACK_FORM_SUCCESS';
export const SEND_FEEDBACK_FORM_FAILURE = 'SEND_FEEDBACK_FORM_FAILURE';

export const sendFeedbackForm = createApiAction(SEND_FEEDBACK_FORM);
